export function addGST(price: number): number {
  const gst = price * 0.15
  const totalPrice = price + gst
  return totalPrice
}
